import { type UserDto } from '../../hooks/useGetUsers';
import { type HttpClient } from '../useHttpClient';

export const fetchAllUsers = (httpClient: HttpClient) => async () => {
  const response = await httpClient.api('/users');

  return response.json as UserDto[];
};
